module.exports = __webpack_public_path__ + "img/971c952a37a84968b271a61729a82d79.0c69c789.jpg";